import { useState, useEffect } from 'react';
import API from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { AlertTriangle, Loader2 } from 'lucide-react';

export default function AdminAnomalies() {
  const [anomalies, setAnomalies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await API.get('/admin/anomalies');
        setAnomalies(data);
      } catch {}
      setLoading(false);
    };
    load();
  }, []);

  const severityColor = (s) => {
    const map = { low: 'bg-slate-100 text-slate-700', medium: 'bg-amber-100 text-amber-800', high: 'bg-rose-100 text-rose-800', critical: 'bg-red-600 text-white badge-pulse' };
    return map[s] || map.medium;
  };

  if (loading) return <div className="flex justify-center pt-20"><Loader2 className="w-8 h-8 animate-spin text-slate-400" /></div>;

  return (
    <div data-testid="admin-anomalies-page">
      <div className="flex items-center gap-3 mb-6">
        <AlertTriangle className="w-6 h-6 text-rose-500" />
        <div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">Anomaly Alerts</h1>
          <p className="text-slate-500 text-sm">{anomalies.length} flags detected</p>
        </div>
      </div>

      {anomalies.length === 0 ? (
        <Card className="border-slate-200 text-center py-12">
          <CardContent>
            <AlertTriangle className="w-12 h-12 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">No anomalies detected</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-3">
          {anomalies.map(a => (
            <Card key={a.id} className="border-slate-200">
              <CardContent className="py-4 px-5">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <Badge className={`text-xs ${severityColor(a.severity)}`}>{a.severity}</Badge>
                      <span className="text-xs font-mono text-slate-400">{a.type}</span>
                    </div>
                    <p className="text-sm text-slate-700">{a.description}</p>
                    <div className="flex gap-4 mt-2 text-xs text-slate-400">
                      {a.user_id && <span>User #{a.user_id}</span>}
                      {a.ip_address && <span>IP: {a.ip_address}</span>}
                      {a.created_at && <span>{new Date(a.created_at).toLocaleString()}</span>}
                    </div>
                  </div>
                  <Badge className={a.resolved ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'} variant="outline">
                    {a.resolved ? 'Resolved' : 'Open'}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
